/**
 * @generated SignedSource<<770703617751e0617edf20a4e06fd124>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTrackExposedReturns_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useEuEligible_viewer">;
  readonly " $fragmentType": "useTrackExposedReturns_viewer";
};
export type useTrackExposedReturns_viewer$key = {
  readonly " $data"?: useTrackExposedReturns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTrackExposedReturns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTrackExposedReturns_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useEuEligible_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9bde8aec0d88f99feb898417126253ce";

export default node;
